import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';

var SingletonFetch = function () {
  var cache = {}; // Cache object to store data
  var fetching = {}; // Track fetch status for specific keys
  var expirationTimeMs = 3600000; // Cache expiration time: 1 hour

  var fetchPluginData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(wpApiUrl, locale, path) {
      var forceRefresh,
        maxRetries,
        retryDelay,
        storageKey,
        expirationKey,
        now,
        result,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            forceRefresh = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
            maxRetries = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : 3;
            retryDelay = _args2.length > 5 && _args2[5] !== undefined ? _args2[5] : 1000;
            if (wpApiUrl) {
              _context2.next = 6;
              break;
            }
            console.error("wpApiUrl not set");
            throw new Error("wpApiUrl not set");
          case 6:
            storageKey = "pluginData_".concat(locale || "default", "_").concat(path || "options");
            expirationKey = "".concat(storageKey, "_timestamp");
            now = Date.now(); // Check cache validity
            if (!(!forceRefresh && cache[storageKey] && cache[expirationKey] && now - cache[expirationKey] < expirationTimeMs)) {
              _context2.next = 11;
              break;
            }
            return _context2.abrupt("return", cache[storageKey]);
          case 11:
            if (!fetching[storageKey]) {
              _context2.next = 13;
              break;
            }
            return _context2.abrupt("return", fetching[storageKey]);
          case 13:
            // Begin a new fetch and store the promise
            fetching[storageKey] = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var retryCount, url, response, data;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    retryCount = 0;
                    url = "".concat(wpApiUrl).concat(locale ? "".concat(locale, "/") : "").concat(path ? path : "wp-json/acf/v3/options/options?_fields=acf.consent_plugin_data");
                  case 2:
                    if (!(retryCount < maxRetries)) {
                      _context.next = 28;
                      break;
                    }
                    _context.prev = 3;
                    _context.next = 6;
                    return fetch(url);
                  case 6:
                    response = _context.sent;
                    if (response.ok) {
                      _context.next = 9;
                      break;
                    }
                    throw new Error("Server Error: ".concat(response.statusText));
                  case 9:
                    _context.next = 11;
                    return response.json();
                  case 11:
                    data = _context.sent;
                    // Cache the fetched data and timestamp
                    cache[storageKey] = data;
                    cache[expirationKey] = Date.now();
                    return _context.abrupt("return", data);
                  case 17:
                    _context.prev = 17;
                    _context.t0 = _context["catch"](3);
                    retryCount++;
                    console.error("Attempt ".concat(retryCount, " failed: ").concat(_context.t0.message));
                    if (!(retryCount >= maxRetries)) {
                      _context.next = 24;
                      break;
                    }
                    console.error("Max retries reached. Throwing error.");
                    throw new Error("Failed to fetch data from ".concat(url, ": ").concat(_context.t0.message));
                  case 24:
                    _context.next = 26;
                    return new Promise(function (resolve) {
                      return setTimeout(resolve, retryDelay);
                    });
                  case 26:
                    _context.next = 2;
                    break;
                  case 28:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[3, 17]]);
            }))();

            // Cleanup fetch tracker once fetch is complete
            _context2.prev = 14;
            _context2.next = 17;
            return fetching[storageKey];
          case 17:
            result = _context2.sent;
            return _context2.abrupt("return", result);
          case 19:
            _context2.prev = 19;
            delete fetching[storageKey];
            return _context2.finish(19);
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[14,, 19, 22]]);
    }));
    return function fetchPluginData(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    fetchPluginData: fetchPluginData
  };
}();
var SingletonFetch$1 = SingletonFetch;

export { SingletonFetch$1 as default };
//# sourceMappingURL=fetchPluginData.js.map
